enum EIppAASIndustrialPretreatmentSettingsActionType {
	FetchIppAASAuthoritySettingsData = 'fetchIppAASIndustrialPretreatmentSettingsData',
	UpdateIppAASAuthoritySettingsData = 'updateIppAASIndustrialPretreatmentSettingsData',
	SaveIppAASAuthoritySettingsData = 'saveIppAASIndustrialPretreatmentSettingsData',
	ToggleSaveButton = 'toggleSaveButton',
	FetchAttachmentTypes = 'fetchFileUploadAttachmentTypes'
}

export default EIppAASIndustrialPretreatmentSettingsActionType;
